import { ExplorerContext, ExplorerContextProps } from '@context/explorer';
import { useContext } from 'react';

export const useExplorer = (): ExplorerContextProps => {
  const context = useContext(ExplorerContext);
  if (!context) {
    throw new Error('useApiContext must be used within an ApiProvider');
  }
  return context;
};
